import {
  Component,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { HelperService } from '../../helper.service';
@Component({
  selector: 'app-mapa-facil',
  templateUrl: './mapa-facil.component.html',
  styleUrls: ['./mapa-facil.component.scss'],
})
export class MapaFacilComponent implements OnInit, OnChanges {
  @Input() coordenada?: google.maps.LatLngLiteral;
  @Input() mapHeight = '200px';
  @Input() iconMarker?: string;
  @Input() mapTypeId?: google.maps.MapTypeId = google.maps.MapTypeId.SATELLITE;
  @Input() mapTypeControl?: boolean = true;

  public mapOptions: google.maps.MapOptions = {
    zoom: 15,
    mapTypeId: this.mapTypeId,
  };

  public markerOptions: google.maps.MarkerOptions = {
    draggable: false,
  };

  private async setMapOptions() {
    this.mapOptions = {
      ...JSON.parse(JSON.stringify(HelperService.mapOptionsMarkerPicker)),
      zoom: 15,
      mapTypeId: this.mapTypeId,
      mapTypeControl: this.mapTypeControl,
      styles: [
        {
          featureType: 'poi',
          elementType: 'labels',
          stylers: [{ visibility: 'off' }],
        },
      ],
    };
  }

  private async updateMarkers() {
    if (this.coordenada) {
      this.markerOptions.position = this.coordenada;
    }
    // agregamos el icono si es que se paso como marker
    if (this.iconMarker) {
      this.markerOptions.icon = {
        url: this.iconMarker!,
        scaledSize: new google.maps.Size(40, 40),
        size: new google.maps.Size(40, 40),
      };
    }
  }

  constructor() { }

  async ngOnInit(): Promise<void> {
    await this.updateMarkers();
    await this.setMapOptions();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.coordenada || changes.iconMarker) {
      this.updateMarkers();
      this.setMapOptions();
    }
  }
}
